import { WeatherIcons } from '$tablet-app/assets/weatherIcons';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';

interface Props {
  time: string;
  icon: string;
  temperature: string;
}

export const WeatherHourItem = (props: Props) => {
  return (
    <Container>
      <Text color="white" variant="p2">
        {props.time.toLowerCase()}
      </Text>
      <Icon source={WeatherIcons[props.icon]} />
      <Text color="white" weight="semibold">
        {props.temperature}
      </Text>
    </Container>
  );
};

const Container = styled.View`
  align-items: center;
  gap: 6px;
`;

const Icon = styled.Image`
  height: 42px;
  width: 42px;
`;
